import { Module } from "vuex";
import { RootState } from "../types";
import { actions } from "./actions";
import { mutations } from "./mutations";
import getters from "./getters";

export const state: FacebookState = {
  campaigns: [],
  advideos: [],
  audiences: [],
  selectedAdvideos: [],
  selectedCampaigns: [],
  adimages: [],
  selectedAdimages: [],
  requests: [],
  accounts: [],
  auth: null,
  errors: [],
  campaignHeadline: "",
  campaignText: ""
};

export interface FacebookState {
  advideos: any[];
  audiences: any[];
  campaigns: [];
  selectedCampaigns: any[];
  selectedAdvideos: any[];
  requests: [];
  auth: any;
  accounts: [];
  adimages: any[];
  selectedAdimages: any[];
  errors: Error[];
  campaignHeadline: string;
  campaignText: string;
}

const namespaced = true;

export const facebook: Module<FacebookState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
